import { styled } from "@mui/material/styles";
import { palette, shadows, typography } from "src/config/theme";
import { Avatar, Typography, alpha, Box } from "@mui/material";
import theme from 'src/config/theme';

export const Texts = styled(Typography)({
    color: palette.gery.black,
    ...theme.typography.smallRegular,
});

export const HiddenComponent = styled(Box)({
    height: '76px',
    display: 'flex',
    gap: '22px',
    justifyContent: 'space-between'
});

export const Component1 = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    width:'350px',
    height: '65px',
});

export const Component2 = styled(Box)({
    height: '65px',
    display: 'flex',
    gap: '14px',
    justifyContent: 'space-between'
});
export const InnerComponent = styled(Box)({
    display: 'flex',
    gap: '4px',
    flexDirection: 'column',
    height: '65px',
    width: '204px',
})
export const Component3 = styled(Box)({
    height: '65px',
    display: 'flex',
    gap: '14px',
    justifyContent: 'space-between'
});
export const Component4 = styled(Box)({
    height: '121px',
    width:'100%',
    display: 'flex',
    gap: '4px',
    flexDirection: 'column',
    justifyContent:'center'
});